import React from 'react';
import './ConvertLeads.css';

const ConvertLeads = () => {
  return (
    <section className="convert-leads" id="convert-leads">
      <div className="convert-bg">
        <span className="convert-glow convert-glow-one"></span>
        <span className="convert-glow convert-glow-two"></span>
        <span className="convert-grid"></span>
      </div>

      <div className="convert-container">
        <div className="convert-badge">
          <span></span>
          Grow Faster With Sales Ninja
        </div>

        <h2 className="convert-title">
          Convert Leads into
          <span>Investors</span>
        </h2>

        <p className="convert-subtitle">
          Join hundreds of advisors already growing their AUM with AI-optimized
          Sales Ninja CRM.
        </p>

        <div className="convert-actions">
          <a href="/#contactus" className="convert-btn convert-btn-primary">
            Book Free Demo
          </a>

          <a href="/#features" className="convert-btn convert-btn-outline">
            See All Features
          </a>
        </div>
      </div>
    </section>
  );
};

export default ConvertLeads;